﻿
cb.define([], function() {
	var AA_aa_alipaysetting_VM_Extend = {
		doAction: function(name, viewmodel) {
			if(this[name])
				this[name](viewmodel);
		},
		init: function(viewmodel) {
			//支付宝配置说明所在的文本框
			viewmodel.addProperty('instructions', new cb.models.SimpleModel());
			viewmodel.get("instructions").setReadOnly(true);
			viewmodel.on('afterLoadData', function(data) {
				var instructions = '支付宝支付设置指南：在进行支付宝参数设置前，请先确保有支付宝支付能力。详情可登录支付宝官方网站，查看各支付场景的接入指南。https://mrchportalweb.alipay.com/settling/selfhelp/accessGuide.htm  查看方式：支付宝接入成功后，登录支付宝，点击PID和公钥管理--开放平台密钥查询APPID，点击mapi网关产品密钥“查询PID、key”；PID为合作伙伴身份以2088开头的16位纯数字，KEY为安全校验码可以通过手机短信验证或输入您的账户支付密码进行查询；';
				viewmodel.get("instructions").setValue(instructions);
				viewmodel.get("instructions").setReadOnly(true);
			});
			viewmodel.on('afterEdit', function (mode){
				viewmodel.get("instructions").setReadOnly(true);
			})
			var storesModel = viewmodel.get("suitableStoreOfAlipay");
			if(storesModel) {
				storesModel.on('beforeBrowse', function(data) {
					if(data) {
						switch(data.cellName) {
							case "store_name":
								//当前页面已选择的门店不再在参照面板中出现
								var rows = storesModel.getRows();
								var storeids = [];
								rows.forEach(function(item, index) {
									if(data.rowIndex === index) return;
									if(item.store_name === undefined) return;
									storeids.push(item.store);
								})
								var condition = {
									"isExtend": true,
									simpleVOs: []
								};
								if(storeids) {
									condition.simpleVOs.push({
										field: 'id',
										op: 'nin',
										value1: storeids
									});
								}
								data.context.setFilter(condition);
								break;
						}
					}
				});
			}
		}
	}
	try {
		module.exports = AA_aa_alipaysetting_VM_Extend;
	} catch(error) {

	}
	return AA_aa_alipaysetting_VM_Extend;
});


// WEBPACK FOOTER //
// ./src/client/business/AA/AA_aa_alipaysetting_VM.Extend.js